import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "../../../../../assets/icons/closeIcon.svg";
import Textarea from "@mui/joy/Textarea";
import "./company-dashboard-initiative-drawer-side-bar.scss";

const CompanyDashboardInitiativeDrawerSideBarDescriptionPopup: any = (
  props: any,
) => {
  const {
    isShowEditDescription,
    setIsShowEditDescription,
    description,
    handleCreateInitiative,
    payloadData,
  } = props;

  const validationSchema = () =>
    Yup.object().shape({
      description: Yup.string().max(
        1000,
        "Description cannot exceed 1000 characters",
      ),
    });
  return (
    <Dialog
      open={isShowEditDescription}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`company-dashboard-initiative-drawer-side-bar-description-popup `}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        setIsShowEditDescription(false);
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <div className="header-wrapper">
          <div className="header-wrapper-text">Description</div>
          <div className="image-wrapper">
            <button
              style={{
                border: "none",
                background: "none",
                padding: 0,
              }}
              onClick={() => setIsShowEditDescription(false)}
            >
              <img
                alt="Close"
                src={CloseIcon}
                className="close-icon"
                style={{ cursor: "pointer" }}
              />
            </button>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Formik
            initialValues={{
              description: description || "",
            }}
            validationSchema={validationSchema}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={(values: any) => {
              handleCreateInitiative(setIsShowEditDescription, {
                ...payloadData,
                description: values.description,
              });
            }}
          >
            {({ values, setFieldValue, errors }) => {
              const charCount = values.description?.length || 0;
              const remaining = 1000 - charCount;
              return (
                <Form>
                  <div className="company-dashboard-initiative-drawer-side-bar-content-description-edit">
                    <div className="company-dashboard-initiative-drawer-side-bar-content-description-edit-content">
                      <Textarea
                        color="neutral"
                        disabled={false}
                        minRows={2}
                        size="lg"
                        variant="outlined"
                        value={values?.description}
                        onChange={(e) =>
                          setFieldValue("description", e.target.value)
                        }
                        placeholder="Enter description here"
                      />
                      <div
                        className={`char-counter ${
                          remaining < 0 ? "error-message" : ""
                        }`}
                      >
                        {charCount} / 1000 characters
                      </div>
                      {errors?.description ? (
                        <div className="error-message">
                          {typeof errors.description === "string"
                            ? errors.description
                            : JSON.stringify(errors.description)}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="company-dashboard-initiative-drawer-side-bar-content-description-edit-action">
                      <button
                        className="company-dashboard-initiative-drawer-side-bar-content-description-edit-action-cancel"
                        onClick={() => setIsShowEditDescription(false)}
                        type="button"
                      >
                        Cancel
                      </button>
                      <button
                        className="company-dashboard-initiative-drawer-side-bar-content-description-edit-action-save"
                        type="submit"
                        disabled={charCount > 1000}
                        style={{
                          opacity: charCount > 1000 ? 0.5 : 1,
                          cursor: charCount > 1000 ? "not-allowed" : "pointer",
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyDashboardInitiativeDrawerSideBarDescriptionPopup;
